import { alias, object, primitive, serializable } from "serializr";
import { ContentLibraryModel } from "../../ContentLibraryModel/contentLibrary.model";
import { ExamChapterModel } from "../ChapterModel/chapter.model";

export class ExamContentModel extends ExamChapterModel{
    @serializable(alias('content_library', object(ContentLibraryModel)))
    contentLibrary?: any;
}

export class UpdateExamContentModel {
    @serializable(alias('title', primitive()))
    title?: string;
    @serializable(alias('description', primitive()))
    description?: string;
    @serializable(alias('exam_chapter_id', primitive()))
    examChapterId?: number;
    @serializable(alias('content_library_id', primitive()))
    contentLibraryId?: number;
    @serializable(alias('is_active', primitive()))
    isActive?: boolean;
  
}